/**
 * TEMPORARY private beta — Compose AI / scam-check feedback access.
 *
 * Source of truth is the server file apps-portal/config/ai_beta_accounts.txt
 * (reloaded live). Clients call getAiBetaAccess() instead of shipping a
 * hardcoded list, so allowlist edits do not require a client rebuild.
 */
let cachedAllowed = null;
let cachedAccountKey = null;
export function clearAiBetaAccessCache() {
    cachedAllowed = null;
    cachedAccountKey = null;
}
/** Last value from getAiBetaAccess (sync UI helpers). */
export function getCachedAiBetaAllowed() {
    return cachedAllowed === true;
}
export function setCachedAiBetaAllowed(allowed, accountKey) {
    cachedAllowed = allowed;
    cachedAccountKey = accountKey ?? cachedAccountKey;
}
export function isComposeAiAllowed(_account) {
    return getCachedAiBetaAllowed();
}
export function isScamCheckAllowed(_account) {
    return getCachedAiBetaAllowed();
}
export function hasComposeAiAllowedAccount(_accounts) {
    return getCachedAiBetaAllowed();
}
/** @deprecated Hardcoded list removed — edit config/ai_beta_accounts.txt on the server. */
export const COMPOSE_AI_ALLOWED_ACCOUNTS = [];
/** @deprecated Use COMPOSE_AI_ALLOWED_ACCOUNTS */
export const COMPOSE_AI_ALLOWED_USERNAMES = COMPOSE_AI_ALLOWED_ACCOUNTS;
